import { render, staticRenderFns } from "./FinanceBanner.vue?vue&type=template&id=3dc1b45c&scoped=true&"
import script from "./FinanceBanner.vue?vue&type=script&lang=ts&"
export * from "./FinanceBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc1b45c",
  null
  
)

export default component.exports